const Aboutus = () => {
  return (
    <main>
      <section className="our-blog">
        <div className="container">
          <div className="about-blog">
            <h2>Обо мне</h2>
            <br />
            Веду проектную деятельность программистом на языках php и
            javascript, немного на C# и 1с7.7,
            <br />
            занимаюсь двумя сайтами интернет-магазинами американских и китайских
            автозапчастей. <br />
            Опыт работы учителем позволил развить во мне такие качества, как
            внимательность к деталям,
            <br />
            стрессоустойчивость, ораторские навыки. Самостоятельная подготовка к
            занятиям в школе сейчас очень помогает мне в программировании.
            <br />
            Буду полезен Вам тем, что знаю несколько языков и умею соединять
            бэкенд и фронтенд, а также разрабатывать сайты по модели Логика-База
            Данных-Интерфейс с помощью Объектно-Ориентированного
            Программирования. <br />
            Изучил курс «Javascript-программирование для начинающих» в
            Нетологии. Теперь решил продолжить развитие карьеры в
            программировании на javascript в frontend стеке и php в backend
            стеке. Рассматриваю проекты в сфере IT, экономики и маркетинга, и
            изучении атома.
            <br />
            Занял 3-е место на Национальном конкурсе Абилимпикс 2024 по 
            веб-разработке по России. В 2025 году участвовал второй раз, 
            занял второе место по России. Это государственные награды от
            Министерства Просвещения РФ.
            <br />
            <br />
            <br />
            <a className="btn" href="/works">
              Портфолио
            </a>
          </div>
          </div>
          </section>
          <section className="work-as work">
            <div className="container">
              <h2>Заинтересованы в работе со мной ?</h2>
              <p>Отправьте письмо здесь и ждите ответа.</p>
              <div>
                <a
                  href="mailto:a@harenkon.ru?subject=вопрос"
                  rel="nofollow"
                  className="btn-black"
                >
                  Напишите мне
                </a>
              </div>
            </div>
          </section>
      <section className="our-blog">
        <div className="container">
          <div className="about-blog">
          <br />
          <br />
          <a className="btn-disabled" href="https://www.aharenkov.ru/my-creative">
            Смотреть идеи
          </a>
          <br />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Aboutus;
